export const stripTrailingSlash = (value) => {
  if (typeof value !== 'string' || !value) return value;
  return value.replace(/\/+$/, '');
};
